import React from "react";

/**
 * Hook to determine if a given element is vertically overlapping with any other elements with the class `color-block`
 */
export function useColorBlockOverlap() {
  const [colorBlocks, setColorBlocks] = React.useState<HTMLElement[]>([]);
  const ref = React.useRef<HTMLElement>(null);
  const [isOverlapping, setIsOverlapping] = React.useState<boolean | null>(
    null
  );

  React.useEffect(() => {
    if (typeof window !== "undefined" && ref.current) {
      const blocks = Array.from(
        document.getElementsByClassName("color-block")
      ) as HTMLElement[];
      setColorBlocks(blocks);
      setIsOverlapping(
        areOverlapping(
          ref.current.getBoundingClientRect(),
          blocks.map((block) => block.getBoundingClientRect())
        )
      );
    }
  }, []);

  React.useEffect(() => {
    const handleScroll = () => {
      if (ref.current && colorBlocks.length) {
        setIsOverlapping(
          areOverlapping(
            ref.current.getBoundingClientRect(),
            colorBlocks.map((block) => block.getBoundingClientRect())
          )
        );
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [colorBlocks]);

  return [ref, isOverlapping] as const;
}

function areOverlapping(target: DOMRect, blocks: DOMRect[]) {
  return blocks.some(
    (block) => !(target.bottom < block.top || target.top > block.bottom)
  );
}
